/*  MyTests.js
    Offers cart similar functionality for My Tests page.
    by Guy E. White <guw968@g.harvard.edu>

    Modified from Cart.js from course instructor Susan Buck:
    https://github.com/susanBuck/e28/tree/master/zipfoods
*/

export default class MyTests {

    /**
     *
     */
    constructor() {
        // Extract JSON mytests string from local storage
        let mytests = localStorage.getItem('mytests');

        // Parse JSON mytests String to `items` object
        this.items = (mytests) ? JSON.parse(mytests) : [];
    }

    /**
     * Getter method for items
     */
    getItems() {
        return this.items;
    }

    /**
     * Returns how many total items are in mytests
     */
    count() {
        let sum = 0;
        for (let key of Object.keys(this.items)) {
            sum += this.items[key].quantity;
        }
        return sum;
    }

    /**
     * Updates mytests in localstorage
     */
    update() {
        localStorage.setItem('mytests', JSON.stringify(this.items))
    }

    /**
     * Add a new item of the given slug
     */
    add(slug, quantity = 1) {

        // First see if product is already present
        let item = this.getItem(slug)

        if (item) {
            // Product is in mytests already; increment quantity by 1
            item.quantity += quantity;

        } else {
            // Product not in mytests, add as new item
            this.items.push({
                slug: slug,
                quantity: quantity
            });
        }

        this.update();
    }

    /**
     * Remove an item from items via slug
     */
    remove(slug) {
        let item = this.getItem(slug);

        let itemIndex = this.items.indexOf(item);

        if (item) {
            this.items.splice(itemIndex, 1);
            this.update();
        }
    }

    /**
     * Get an item from items via slug
     * Returns null if product does not exist in items
     */
    getItem(productSlug) {
        return this.items.find(({ slug }) => slug === productSlug) || null;
    }
}
